import React, { memo } from 'react';
import { formatBytes } from '../../../utils';
import { CustomFormFieldState } from '../../../FormControls/CustomFormField/CustomFormField';

type FileDetailsProps = {
	fileNameLabel: string;
	fileTypeLabel: string;
	fileSizeLabel: string;
	fileDetails: CustomFormFieldState['fileDetails'];
}
const FileDetails: React.FC<FileDetailsProps> = (props: FileDetailsProps) => {

	const { fileNameLabel, fileTypeLabel, fileSizeLabel, fileDetails } = props

	if (!fileDetails) return null
	return (
		<dl className={'description-list'}>
			<dt>{fileNameLabel}:</dt>
			<dd>{fileDetails?.fileName || ''}</dd>
			<dt>{fileTypeLabel}:</dt>
			<dd>{fileDetails?.fileType}</dd>
			<dt>{fileSizeLabel}:</dt>
			<dd>{formatBytes(fileDetails?.fileSize)}</dd>
		</dl>
	)
}
export default memo(FileDetails)
